import React from 'react';
import PropTypes from 'prop-types';
import './logo.scss';

const Logo = ({
    variant = 'header',
    className = '',
    style = {},
    alt = 'Prakash Astrologer Logo',
    ...props
}) => {
    const logoUrl = 'https://prakashastrologer-19e87.kxcdn.com/wp-content/uploads/2020/05/PrakashAstrologerLogo.svg';

    const getVariantClass = () => {
        switch (variant) {
        case 'header':
            return 'logo-header';
        case 'login':
            return 'logo-login';
        case 'large':
            return 'logo-large';
        case 'small':
            return 'logo-small';
        default:
            return 'logo-default';
        }
    };

    const combinedClassName = `prakash-logo ${getVariantClass()} ${className}`;

    return (
        <img
            src={logoUrl}
            alt={alt}
            className={combinedClassName}
            style={style}
            {...props} />
    );
};

Logo.defaultProps = {
    variant: 'header',
    className: '',
    style: {},
    alt: 'Prakash Astrologer Logo',
};

Logo.propTypes = {
    variant: PropTypes.oneOf(['header', 'login', 'large', 'small', 'default']),
    className: PropTypes.string,
    style: PropTypes.object,
    alt: PropTypes.string,
};

export default Logo;
